export const words = [
    'Apostillas',
    'Escrituras',
    'Sucesiones',
    'Divorcios',
    'Fideicomisos',
    'Registros digitales',
    'Certificados de tradicion',
    'Expedicion de registros',
    'Liquidaciones',
    'Desistimientos',
    'Poderes',
    'Contratos de compraventa',
    'Contratos de arrendamiento',
    'Acuerdos de voluntades',
    'apostillas',
    'escrituras',
    'sucesiones',
    'divorcios',
    'fideicomisos',
    'registros digitales',
    'certificados de tradicion',
    'expedicion de registros',
    'liquidaciones',
    'desistimientos',
    'poderes',
    'acuerdos de voluntades'
]